<template>
  <div :class="[{ root: true, sidebarClose, sidebarStatic }, 'sing-dashboard']">
    <Sidebar />
    <!-- <Helper /> -->
    <div class="wrap">
      <Header />
      <div class="content" @swipe="handleSwipe" :swipe-options="{ direction: 'horizontal' }">
        <transition name="router-animation">
          <router-view />
        </transition>
        <footer class="contentFooter">
          <div class="row">
            <div class="col-12">
              <div style="font-size: 0.8em !important">
                <router-link :to="{ name: 'ViewHistory' }" v-if="$session.get('CustomerInfo') == undefined"> [ نسخه : {{
                  this.$store.state.VersionSoftware }} ] </router-link>
                <span class="text-secondary">[ {{ $session.get('CustomerInfo') ?
                  this.$session.get('CustomerInfo').CustomerName : 'سمت کاربر : ' + this.$session.get('UserInfo').gName }}
                  ]</span>
                سامانه جامع مدیریت مشتریان شرکت پاسارگاد <a href="https://bnpco.ir" rel="nofollow noopener noreferrer"
                  target="_blank">bnpco.ir</a>
              </div>
            </div>
          </div>
        </footer>
      </div>

      <Messenger v-if="!isCustomer"></Messenger>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('layout')

import Sidebar from '@/components/Sidebar/Sidebar'
import Header from '@/components/Header/Header'
import './Layout.scss'
import Messenger from '@/pages/BnpCrm/Messenger/Messenger.vue'

export default {
  name: 'Layout',
  components: { Sidebar, Header, Messenger },
  methods: {
    ...mapActions(['switchSidebar', 'handleSwipe', 'changeSidebarActive', 'toggleSidebar']),
    handleWindowResize() {
      const width = window.innerWidth

      if (width <= 768 && this.sidebarStatic) {
        this.toggleSidebar()
        this.changeSidebarActive(null)
      }
    },

    async chatHub() {
      this.$GetSignalRChat().then((res) => {
        this.signalRChatConnection = res
        this.connectionIdChat = res.connection.connectionId

        // تلاش برای اتصال هاب در صورت قطع شدن
        // this.signalRChatConnection.onclose(() => {
        //   if (!this.manualStopHub) {
        //     this.chatHubInterval = false
        //     this.chatHubInterval = setInterval(this.tryConnectChatHub, 1000)
        //   }
        // })

        res.invoke('UserJoinGropForMessageNotif', String(this.$session.get('UserInfo').tblUserId))
        res.on('getNotifNewMessageForUser', (ChatRoomId, tblUserId, ticketId, TblComboGrpId41, TblDepartmentId, CustomerName, CustomerCode, tblCustomerId, grp42, grp45) => {
          console.log("NotifNewMessage");
          var vueThis = this
          const notification = {
            title: this.isCustomer ? 'سامانه جامع ارتباط مشتریان پاسارگاد' : CustomerName,
            options: {
              body: 'شما یک پیام جدید دریافت کردید',
              icon: 'https://bnpco.ir/favicon.ico',
            },
            events: {
              onclick: function () {
                vueThis.$router.push({
                  name: 'ChatRoom',
                  params: {
                    chatRoomId: ChatRoomId,
                    ticketManagerTblUserId: tblUserId,
                    ticketId: ticketId,
                    tblComboIdTicketStatus: TblComboGrpId41,
                    departmentId: TblDepartmentId,
                    customerName: CustomerName,
                    customerCode: CustomerCode,
                    tblCustomerId: tblCustomerId,
                    tblComboGrpId45: grp45,
                    tblComboGrpId42: grp42
                  },
                })

              },
            },
          }
          this.$notification.show(notification.title, notification.options, notification.events)
        })
      })
    },

    async ticketHub() {
      this.$GetSignalR().then((res) => {
        this.signalRTicketConnection = res
        this.connectionId = res.connection.connectionId

        // تلاش برای اتصال هاب در صورت قطع شدن
        // this.signalRTicketConnection.onclose(() => {
        //   if (!this.manualStopHub) {
        //     this.ticketHubConnected = false
        //     this.ticketInterval = setInterval(this.tryConnectTicketHub, 1000)
        //   }
        // })
        res.invoke('UserJoinGroup', String(this.$session.get('UserInfo').tblUserId))
       
        if (this.$session.get("UserInfo").isNotificationTicket) {
          res.on('GetNotif', () => {
            // this.$mySweetDefaultTost('شما یک تیکت دارید')
            var vueThis = this
            const notification = {
              title: 'اعلان',
              options: {
                body: 'دپارتمان شما یک تیکت دارد',
                icon: 'https://bnpco.ir/favicon.ico',
              },
              events: {
                onclick: function () {
                  if (vueThis.$route.name != 'Tickets') {
                    vueThis.$router.push({
                      name: 'Tickets',
                    })
                  }
                },
              },
            }
            this.$notification.show(notification.title, notification.options, notification.events)
          })
        }


        res.on('ReferenceTicketNotif', (res2) => {
          var vueThis = this
          const notification = {
            title: 'اعلان',
            options: {
              body: 'یک تیکت به شما ارجاع شد',
              icon: 'https://bnpco.ir/favicon.ico',
            },
            events: {
              onclick: function () {
                vueThis.$router.push({
                  name: 'Tickets',
                })
              },
            },
          }
          this.$notification.show(notification.title, notification.options, notification.events)
        })
      })
      // .finally(() => {
      //   if (this.signalRTicketConnection._connectionStarted === false || this.signalRTicketConnection == null) {
      //     setTimeout(() => {
      //       this.ticketHub()
      //     }, 1000)
      //   }
      // })
    },

    tryConnectTicketHub() {
      if (!this.ticketHubConnected) {
        if (!this.manualStopHub) {
          this.ticketHub().then(() => {
            this.ticketHubConnected = true
            clearInterval(this.ticketInterval)
          })
        }
      }
    },

    tryConnectChatHub() {
      if (!this.chattHubConnected) {
        if (!this.manualStopHub) {
          this.chatHub().then(() => {
            this.chattHubConnected = true
            clearInterval(this.chatHubInterval)
          })
        }
      }
    },
  },
  computed: {
    ...mapState(['sidebarClose', 'sidebarStatic']),
  },
  data() {
    return {
      signalRTicketConnection: null,
      signalRChatConnection: null,
      connectionId: null,
      connectionIdChat: null,
      isCustomer: this.$session.get('CustomerInfo') != undefined && this.$session.get('CustomerInfo').Id > 0 ? true : false,
      manualStopHub: false,
      ticketHubConnected: false,
      chattHubConnected: false,
      chatHubInterval: null,
      ticketInterval: null,
      userId: this.$session.get('UserInfo').tblUserId,
    }
  },
  created() {
    this.chatHub()
    this.ticketHub()

    const staticSidebar = JSON.parse(localStorage.getItem('sidebarStatic'))

    if (staticSidebar) {
      this.$store.state.layout.sidebarStatic = true
    } else if (!this.sidebarClose) {
      setTimeout(() => {
        this.switchSidebar(true)
        this.changeSidebarActive(null)
      }, 2500)
    }
    this.$store.state.TickCPFilter = { value: [1791, 1793, 1794, 1795, 1797, 1798, 1841, 1842], value2: [], value3: [], value4: [], customerId: null },
      this.$store.state.TickCPFilter.value3.push(this.userId)

    this.handleWindowResize()
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy() {
    // if(this.$session.get('UserInfo') != undefined){
    //   this.signalRTicketConnection.invoke('RemoveFromGroup', this.connectionId, String(this.$session.get('UserInfo').tblUserId))
    //   this.signalRChatConnection.invoke('UserRemoveGropForMessageNotif', this.connectionIdChat, String(this.$session.get('UserInfo').tblUserId))
    // }

    this.$store.state.TickCPFilter = { value: [1791, 1793, 1794, 1795, 1797, 1798, 1841, 1842], value2: [], value3: [], value4: [], customerId: null },

      this.manualStopHub = true
    this.signalRChatConnection.stop().then(() => {
      this.manualStopHub = true
      clearInterval(this.chatHubInterval)
    })

    this.signalRTicketConnection.stop().then(() => {
      this.manualStopHub = true
      clearInterval(this.chatHubInterval)
    })

    window.removeEventListener('resize', this.handleWindowResize)
  },
}
</script>

<style src="./Layout.scss" lang="scss" />
<style>
.content {
  background: var(--sidebar-action-bg);
}

[data-title]:hover:after {
  opacity: 1;
  transition: all 0.1s ease 0.5s;
  visibility: visible;
}

[data-title]:after {
  content: attr(data-title);
  background-color: #000;
  white-space: nowrap;
  color: #fff;
  font-size: normal;
  position: absolute;
  padding: 1px 5px 2px 5px;
  top: 2rem;
  left: 0;
  box-shadow: 1px 1px 3px #222222;
  opacity: 0;
  border: 1px solid #111111;
  border-radius: 5px;
  z-index: 99999;
  visibility: hidden;
}

[data-title] {
  position: relative;
}</style>
